import { createFileRoute } from '@tanstack/react-router'
import { EquipmentPage } from '~/features/operations/EquipmentPage'
import { equipmentQuery } from '~/features/operations/queries'
import { Gate, RouteError } from '~/features/operations/shared'
import { mayRead } from '~/features/org/guard'

export const Route = createFileRoute('/_app/verein/betrieb/inventar')({
  loader: async ({ context }) => {
    if (await mayRead(context.queryClient, 'ops.read')) await context.queryClient.ensureQueryData(equipmentQuery())
  },
  component: () => (
    <Gate permission="ops.read">
      <EquipmentPage />
    </Gate>
  ),
  errorComponent: RouteError,
})
